"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _excluded = ["classes", "className", "Icon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      bottom: -56 / 2,
      left: 24,
      color: theme.palette.common.white,
      zIndex: theme.zIndex.appBar + 1
    }
  };
};

var PresetFab = function PresetFab(_ref) {
  var classes = _ref.classes,
      classNameProp = _ref.className,
      Icon = _ref.Icon,
      other = _objectWithoutProperties(_ref, _excluded);

  var className = (0, _classnames["default"])(classes.root, classNameProp);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    variant: "fab",
    color: "primary",
    className: className
  }, other), /*#__PURE__*/_react["default"].createElement(Icon, null));
};

PresetFab.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  Icon: _propTypes["default"].number
};
PresetFab.defaultProps = {
  className: '',
  Icon: _Add["default"]
};

var _default = (0, _styles.withStyles)(styles)(PresetFab);

exports["default"] = _default;